import React from 'react';
import Title from 'antd/lib/typography/Title';
import { FormattedMessage } from 'react-intl';
import { inspectionShape } from '../utility/inspection-util';


/**
 * Displays the notes that are linked to an inspection.
 * @param {object} inspection The inspection being displayed.
 */
export default function InspectionNotes({ inspection }) {
  const notes = inspection.notes || [];
  const inspector = inspection.createdBy && inspection.createdBy.displayName;
  const viewNote = notes.length > 0 ? notes[0].note : '';


  return (
    <div>
      <Title level={3} style={{ display: viewNote === '' ? 'none' : '' }}><FormattedMessage id="notes" /></Title>
      <blockquote cite={inspector} className="inspection-quote">
        { viewNote.split('\n').map(paragraph => (<p key={paragraph}>{paragraph}</p>)) }
      </blockquote>
    </div>
  );
}

InspectionNotes.propTypes = {
  inspection: inspectionShape.isRequired,
};
